import { call, put, takeLatest } from "redux-saga/effects";
import { TreatmentPlanTemplatesAPI } from "../../../api/treatmentPlansAPI";
import { ToastType } from "../../../utils/interfaces";
import {
  APPLY_MEDICATION_TEMPLATE_ERROR,
  APPLY_MEDICATION_TEMPLATE_REQUEST,
    APPLY_MEDICATION_TEMPLATE_SUCCESS,
    GET_PATIENT_SCHEDULES_REQUEST,
    SET_TOAST,
} from "../../actions";

function* workerApplyMedicationTemplate(action: {
  type: string;
  payload: {
    patientId: any, startDate: any, templateId: any, callback: () => void,
  };
}): Generator<any> {
  try {
    const { patientId, startDate, templateId, callback } = action.payload;
    yield call(TreatmentPlanTemplatesAPI.applyMedicationTemplate, patientId, startDate, templateId);
    yield put({
      type: APPLY_MEDICATION_TEMPLATE_SUCCESS,
    });
    yield put({
      type: GET_PATIENT_SCHEDULES_REQUEST,
      payload: { patientId }
    });
    yield put({
      type: SET_TOAST,
      payload: {
        open: true,
        message: "Medication template was successfully applied",
        type: ToastType.SUCCESS,
      }
    });
    callback();
  } catch (error: any) {
    yield put({
      type: APPLY_MEDICATION_TEMPLATE_ERROR,
      payload: { code: error.response.status, message: error.message }
    });
  }
}

export function* watcherApplyMedicationTemplate() {
  yield takeLatest(APPLY_MEDICATION_TEMPLATE_REQUEST, workerApplyMedicationTemplate);
}